var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.46875 1.125C3.51748 1.125 1.125 3.51748 1.125 6.46875C1.125 9.42002 3.51748 11.8125 6.46875 11.8125C9.42002 11.8125 11.8125 9.42002 11.8125 6.46875C11.8125 3.51748 9.42002 1.125 6.46875 1.125ZM0 6.46875C0 2.89616 2.89616 0 6.46875 0C10.0413 0 12.9375 2.89616 12.9375 6.46875C12.9375 10.0413 10.0413 12.9375 6.46875 12.9375C2.89616 12.9375 0 10.0413 0 6.46875Z",
    fill: "#035C98"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2476 10.2476C10.4672 10.0279 10.8234 10.0279 11.0431 10.2476L14.4602 13.6648C14.6799 13.8844 14.6799 14.2406 14.4602 14.4602C14.2406 14.6799 13.8844 14.6799 13.6648 14.4602L10.2476 11.0431C10.0279 10.8234 10.0279 10.4672 10.2476 10.2476Z",
    fill: "#035C98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.9a8b26cf610c023cdcbb7500ba5779d1.svg";
export { ForwardRef as ReactComponent };